import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { State } from "../../store";
import { isTTPayEnabled, TTPAY_FOOTER_ANCHOR_ID, TTPAY_NAME } from "../../utils/termsLinks";
import "./TTPayCheckoutNotice.scss";

const TTPayCheckoutNotice: React.FC = () => {
  const { t } = useTranslation();
  const configuration = useSelector((state: State) => state.config.configuration);

  if (!isTTPayEnabled(configuration)) {
    return null;
  }

  const handleScrollToFooter = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById(TTPAY_FOOTER_ANCHOR_ID)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <p className="ttpay-checkout-notice">
      {t("ttpay_checkout_notice_before")} <b>{TTPAY_NAME}</b>
      {t("ttpay_checkout_notice_after")}{" "}
      <a href={`#${TTPAY_FOOTER_ANCHOR_ID}`} onClick={handleScrollToFooter}>
        {t("ttpay_who_handles_payment")}
      </a>
    </p>
  );
};

export default TTPayCheckoutNotice;
